module.exports = __webpack_public_path__ + "media/images/landing/banner_01.en-54116f538ebe02d5f11afc69253a0ac7.png";